import KogModalComponent from "../../modal/ModalComponent";
import PDFViewer from "../pdfViewer/pdfViewer";
import { useAcceptanceTermsFlow } from "./useAcceptanceTermsFlow";

function AcceptanceTermsModal() {
	const { isOpen, urlFile, currentIndex, isLoadingSave, titleModal, handleAccept, handleDecline } =
		useAcceptanceTermsFlow();

	return (
		<KogModalComponent
			disabledCloseIcon
			title={titleModal}
			size="large"
			open={isOpen}
			hasActionConfirm={false}
			hasActionCancel={false}
			handleClose={() => {}}
			content={
				<PDFViewer
					key={currentIndex}
					urlFile={urlFile}
					isLoading={isLoadingSave}
					onAccept={handleAccept}
					onDecline={handleDecline}
				/>
			}
		/>
	);
}

export default AcceptanceTermsModal;
